<script lang="ts">
  import type { Channel } from '../../../../../firebase/api/channel';
  import type { FeedAbstract } from '../../../../../firebase/common/feed';
  import type { Plan } from '../../../../../firebase/common/plan';
  import { checkoutPlan } from '../../../../../utils/checkout';
  import PlanCard from '../../PlanCard.svelte';

  export let feed: FeedAbstract;
  export let channel: Channel;
  export let requiredPlan: Plan;

  export let subscriber: string | null;

  const date = feed.published_at.toLocaleDateString();
  const hours = feed.published_at.getHours().toString().padStart(2, '0');
  const minutes = feed.published_at.getMinutes().toString().padStart(2, '0');
</script>

<div class="feed-cover">
  <img src={feed.thumbnail} alt="{feed.title}のカバー画像" />
  <div class="over" />
</div>
<div class="content">
  <div class="heading">
    <h2>{feed.title}</h2>
    <div class="published-at">
      <time datetime={feed.published_at.toISOString()}>
        {date}
        {hours}時{minutes}分
      </time>
      <div class="creator-name">
        <a href="/c/{channel.display_name}">{channel.name}</a>
      </div>
    </div>
  </div>
  <article class="plan">
    <div class="plan-warning">
      <h3>このフィードを見るには、プランの購読が必要です。</h3>
    </div>
    <PlanCard plan={requiredPlan} narrow onPlanSubscribe={checkoutPlan(subscriber, channel.id, requiredPlan.price)} />
  </article>
</div>

<style lang="scss">
  $sp-width: 456px;
  $tb-width: 880px;
  .heading {
    h2 {
      word-break: break-all;
      margin: 0 0 0.5rem;
      line-height: 1.65;
    }

    .published-at {
      display: flex;
      align-items: center;
      grid-column-gap: 1rem;
      margin-bottom: 1.5rem;
      padding-bottom: 1.5rem;
      border-bottom: 1px solid var(--border-gray);
    }

    time,
    .creator-name {
      font-size: 100%;
      text-align: end;
    }

    time {
      color: var(--text-gray);
    }

    a {
      font-weight: bold;
      text-decoration: none;
    }
  }

  .feed-cover {
    position: relative;
    aspect-ratio: 33/17;
    :global(.owner-edit) {
      position: absolute;
      pointer-events: all;
      right: 1rem;
      top: 1rem;
      background: #ffffffc0;
      border-radius: 9in;
      z-index: 10;
    }

    img {
      width: 100%;
      // サムネイル画像の全体が見えるように、高さ指定をコメントアウトした
      // height: 100%;
      object-fit: cover;
      object-position: top;
    }
  }

  .content {
    margin: 2rem 0 3rem;
    min-height: inherit;
    position: relative;
    z-index: 1;
    padding: 0 3rem;
  }

  .plan {
    > :global(.card.narrow) {
      padding: 0;
      width: 100%;
      margin: 0;
    }
    &-warning {
      margin: 0 0 2rem;
      padding: 0.8rem 1rem 0.9rem;
      border-radius: 0.5rem;
      background-color: var(--bg-sub);
      text-align: center;
      > h3 {
        margin: 0;
        font-size: 1rem;
        color: var(--text-gray);
      }
    }
  }
  @media screen and (max-width: #{$tb-width}) {
    .heading {
      h2 {
        margin: 0 0 0.3rem;
        font-size: 1.2rem;
      }

      .published-at {
        margin-bottom: 1.3rem;
        padding-bottom: 1.3rem;
      }

      time,
      .creator-name {
        font-size: 0.9rem;
      }
    }

    .content {
      margin: 1rem 0 1.5rem;
      padding: 0 1.2rem;
    }
  }
</style>
